import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IProcessStatus } from '@app/interfaces/process.interface';

@Component({
	selector: 'app-show-process',
	templateUrl: './show-process.component.html',
	styleUrls: ['./show-process.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShowProcessComponent {
	@Input() process: IProcessStatus = IProcessStatus.loading;
	readonly PROCESS_STATUS: typeof IProcessStatus = IProcessStatus;
}
